import moment from 'moment'

const appointmentDashboardService = require('./appointmentDashboardService')

const state = {
  dashboardAppointments: [],
  dashboardAppointmentsCount: {},
}

const getters = {
  dashboardAppointments: (state) => state.dashboardAppointments,
  dashboardAppointmentsCount: (state) => state.dashboardAppointmentsCount,
}

const actions = {
  async fetchDashboardAppointments({ commit, dispatch, rootState }) {
    commit('setIsLoading', true)
    const defaultParams = {
      size: 150,
      page: rootState.paginate.currentPage - 1,
      orderBy: 'DESC'
    }
    const params = { ...defaultParams, ...rootState.filters.filters }

    if (!params.hasOwnProperty('startDate')) params.startDate = moment().add(-100, 'days').format('YYYY-MM-DD') + 'T00:00:01Z'
    if (!params.hasOwnProperty('endDate') || params.endDate == '') params.endDate = moment(params.startDate).add(101, 'days').format('YYYY-MM-DD') + 'T23:59:59Z'

    appointmentDashboardService.list(params)
      .then(({ data }) => {
        const { result, size, total } = data
        commit('setDashboardAppointments', result)
        commit('setItemsPerPage', size)
        commit('setTotalPages', total)
      })
      .catch(({ data }) => {
        data?.errors && data?.errors?.length >= 1
          ? dispatch('showErrorMessage', data.errors[0].message)
          : dispatch('showErrorMessage', data.message)
      })
      .finally(() => {
        commit('setIsLoading', false)
      })
  },

  async fetchDashboardAppointmentsCount({ commit, dispatch, rootState }) {
    commit('setIsLoading', true)

    const params = { ...rootState.filters.filters }

    if (!params.hasOwnProperty('startDate')) params.startDate = moment().add(-100, 'days').format('YYYY-MM-DD') + 'T00:00:01Z'
    if (!params.hasOwnProperty('endDate') || params.endDate == '') params.endDate = moment(params.startDate).add(101, 'days').format('YYYY-MM-DD') + 'T23:59:59Z'

    appointmentDashboardService.countApppointmentByStatus(params)
      .then(({ data }) => {
        commit('setDashboardAppointmentsCount', data)
      })
      .catch(({ data }) => {
        data?.errors && data?.errors?.length >= 1
          ? dispatch('showErrorMessage', data.errors[0].message)
          : dispatch('showErrorMessage', data.message)
      })
      .finally(() => {
        commit('setIsLoading', false)
      })
  },

  async generateAppointmentDashboardReport({ rootState }) {
    const params = { ...rootState.filters.filters }

    if (!params.hasOwnProperty('startDate')) params.startDate = moment().add(-100, 'days').format('YYYY-MM-DD') + 'T00:00:01Z'
    if (!params.hasOwnProperty('endDate') || params.endDate == '') params.endDate = moment(params.startDate).add(101, 'days').format('YYYY-MM-DD') + 'T23:59:59Z'

    return appointmentDashboardService.generateAppointmentDashboardReport(params)
  }
}

const mutations = {
  setDashboardAppointments: (state, dashboardAppointments) => {
    state.dashboardAppointments = dashboardAppointments
  },

  setDashboardAppointmentsCount: (state, dashboardAppointmentsCount) => {
    state.dashboardAppointmentsCount = dashboardAppointmentsCount
  },
}

export default {
  state,
  mutations,
  actions,
  getters,
}
